<template>
<panel>
  <p slot="header">Twój profil</p>
  <p slot="actions">
    <ui-button color="primary" type="flat" @click="$router.push({ name: 'admin.change-password'})">Zmień hasło</ui-button>
    <ui-button color="primary" type="flat" @click="$router.push({ name: 'logout'})">Wyloguj się</ui-button>
  </p>
  <table class="table info-table">
    <tr>
      <th class="short">
        Imię i nazwisko
      </th>
      <td>
        {{ user.first_name }} {{ user.last_name }}
      </td>
    </tr>
    <tr>
      <th>
        E-mail
      </th>
      <td>
        <a :href="href(user.email)">{{ user.email }}</a>
      </td>
    </tr>
  </table>
</panel>

</template>
<script>
import Auth from './../../services/Auth'
import EventEmitter from './../../services/EventEmitter'

export default {
  data () {
    return {
      user: {
        email: null
      }
    }
  },
  methods: {
    href (email) {
      return 'mailto: ' + email
    },
    success (res) {
      this.user = res.data.user
      EventEmitter.$emit('admin.loading', false)
    }
  },
  mounted () {
    EventEmitter.$emit('admin.loading', true)
    Auth.my().then(this.success)
  }
}

</script>


// WEBPACK FOOTER //
// My.vue?5cd15871